export const SCOUT_LAUNCH_URL = "https://support.encamp.com/en/articles/11972993";

export const SCOUT_LAUNCH_MODAL_COPY = {
  headline: "Meet Scout",
  subheadline: "Encamp's new compliance expert",
  learnMoreLabel: "Learn more about Scout",
  startTourLabel: "Show me where it is",
} as const;

export type ScoutLaunchTourStepConfig = {
  step: 1 | 2;
  anchorId: string;
  title: string;
  body: string;
  placement: "bottom" | "right";
};

export const SCOUT_LAUNCH_TOUR_STEPS: ScoutLaunchTourStepConfig[] = [
  {
    step: 1,
    anchorId: "scout-launcher",
    title: "Talk to Scout",
    body: "Ask Scout questions from anywhere in the platform.",
    placement: "bottom",
  },
  {
    step: 2,
    anchorId: "scout-nav",
    title: "The full Scout experience",
    body: "Access your Scout history and citation records whenever you need them.",
    placement: "right",
  },
];

export const SCOUT_LAUNCH_TOUR_TOTAL_STEPS = SCOUT_LAUNCH_TOUR_STEPS.length;
